import Gateway from '../Gateway.js';
import cookie from 'cookie';

export default class TrackingIpFilter {
  static get key() {
    return 'trackingIpFilter';
  }

  static get() {
    const cookies = cookie.parse(Gateway.window.document.cookie);
    return cookies && cookies[this.key] === 'true';
  }
}
